import { render, staticRenderFns } from "./file-upload-multiple.vue?vue&type=template&id=20904814&scoped=true&"
import script from "./file-upload-multiple.vue?vue&type=script&lang=js&"
export * from "./file-upload-multiple.vue?vue&type=script&lang=js&"
import style0 from "./file-upload-multiple.vue?vue&type=style&index=0&id=20904814&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20904814",
  null
  
)

export default component.exports